import request from '@js/builders/request_builder'
import store from '@vuex'

import { initHorizonServer } from '../helpers/server.helper'
import { operationBuilder } from '../builders/operation_builder/operation_builder'
import get from 'lodash/get'

export class Service {
  /**
   * Service to work with offers
   * @param [opts]
   * @param {string} [opts.userAccountId]
   * @param {ArrayBuffer} [opts.userKeypair]
   * @param [opts.apiRequestBuilder]
   * @param [opts.horizonRequestBuilder]
   * @param [opts.accountId]
   * @param [opts.keypair]
   */
  constructor (opts) {
    this._apiRequestBuilder = get(opts, 'apiRequestBuilder') || request
    this._operationBuilder = operationBuilder
    this._overwrittenKeypair = get(opts, 'keypair')
    this._overwrittenAccountId = get(opts, 'accountId')
  }

  get _horizonRequestBuilder () {
    return this._networkId !== undefined && this._networkId.length ? initHorizonServer(this._networkId) : undefined
  }

  get _accountId () {
    return this._overwrittenAccountId || store.getters.accountId
  }

  get _accountIdOrMerchatId () {
    return store.getters.merchantUserId || store.getters.accountId || this._overwrittenAccountId
  }

  get _publicKey () {
    return store.getters.accountPublicKey
  }

  get _networkId () {
    return store.getters.networkPassphrase
  }

  get _keypair () {
    return this._overwrittenKeypair || store.getters.accountKeypair
  }

  get _walletId () {
    return store.getters.walletId
  }
}



// WEBPACK FOOTER //
// ./src/js/services/service.js